import { render, staticRenderFns } from "./generate-report-assignments-button.vue?vue&type=template&id=74cc0977"
import script from "./generate-report-assignments-button.vue?vue&type=script&lang=js"
export * from "./generate-report-assignments-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports